import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import Icon from "../../Atoms/Icon";
import CompanyAvatar from "../../Atoms/Avatars/CompanyAvatar";
import {useMedia} from "../../../hooks/useMedia";
import {mediaFromM, mediaToM} from "../../../helpers/media-queries";
import EditTextButton from "../../Atoms/Buttons/EditTextButton";
import DeleteTextButton from "../../Atoms/Buttons/DeleteTextButton";
import CompanyInformationModal from "../Modals/CompanyInformationModal";
import DeleteCompanyModal from "../Modals/DeleteCompanyModal";

const CompanyHeader = props => {
  const fromM = useMedia(mediaFromM)
  const toM = useMedia(mediaToM)

  const informationModal = useRef()
  const deleteModal = useRef()

  const handleOpenInformationModal = () => {
    informationModal.current.openModal()
  }

  const handleOpenDeleteModal = () => {
    deleteModal.current.openModal()
  }

  return (
    <>
      <header className="n-container m-main-justify">
        <div className="flex nowrap s-flex-gap-16px">
          <CompanyAvatar
            size="s-h-64px s-w-64px"
            name="Discord"
            src="https://cdn.svgporn.com/logos/discord-icon.svg"
          />
          <div>
            <div className="s-main-justify s-cross-center s-mb-12px m-mb-4px">
              <h1 className="t2 s-mb-0">Discord</h1>
              {toM && (
                <div className="s-cross-center">
                  <EditTextButton className="s-mr-8px" onClick={handleOpenInformationModal()} />
                  <DeleteTextButton onClick={handleOpenDeleteModal}/>
                </div>
              )}
            </div>
            <div className="s-cross-center">
              <div className="s-cross-start s-mr-16px nowrap">
                <Icon svg="identification"
                  className="s-mr-4px"/>
                <p className="s-mb-0">No. identificación 143 543 567 - <span className="s-color-title">DV 6</span></p>
              </div>
              <div className="s-cross-center">
                <Icon svg="web"
                  className="s-mr-4px"/>
                <a href="https://discord.com">Discord</a>
              </div>
            </div>
          </div>
        </div>

        {fromM && (
          <div className="buttons-container">
            <button className="button ghost" onClick={handleOpenInformationModal} >Editar</button>
            <button className="button ghost delete" onClick={handleOpenDeleteModal}>Eliminar</button>
          </div>
        )}
      </header>
      <CompanyInformationModal ref={informationModal} />
      <DeleteCompanyModal ref={deleteModal}/>
    </>
  );
};

CompanyHeader.propTypes = {};

export default CompanyHeader;
